var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / LR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-LR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,16 L28,18.6666667 L0,18.6666667 L0,16 L28,16 Z M28,10.6666667 L28,13.3333333 L13.3333333,13.3333333 L13.3333333,10.6666667 L28,10.6666667 Z M28,5.33333333 L28,8 L13.3333333,8 L13.3333333,5.33333333 L28,5.33333333 Z M28,0 L28,2.66666667 L13.3333333,2.66666667 L13.3333333,0 L28,0 Z",
    id: "Rectangle-537",
    fill: "#E1244A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1568",
    fill: "#0C3F8E",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 13.3333333,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "6.66666667 8.22666673 4.31552566 9.90273464 5.18301844 7.1487332 2.8624406 5.43059869 5.74972164 5.40460011 6.66666667 2.66666667 7.5836117 5.40460011 10.4708927 5.43059869 8.15031489 7.1487332 9.01780768 9.90273464"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/LR.d38914d614c3b42efa2270121a30db48.svg";
export { ForwardRef as ReactComponent };